
import { IsEnum, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';
export class IndentRequest {
    @ApiProperty()
    indentId: number;
}
